import { COLLECTIONS } from "constants/action-types";
import { EventTypes } from "redux-segment";

export const changeSearchTerm = (value: string) => ({
    payload: value,
    type: COLLECTIONS.COLLECTION.PERMISSIONS.CONTACTS.SEARCH,
});

export const fetchContacts = (search = "", merchant_id?: string, brandId?: string) => ({
    payload: {
        search,
        merchant_id,
        brandId,
    },
    type: COLLECTIONS.COLLECTION.PERMISSIONS.CONTACTS.FETCH.START,
});

export const addPermission = ({ collectionId, userIds, permission }) => {
    return {
        meta: {
            analytics: EventTypes.track,
        },
        payload: {
            collectionId,
            permission,
            userIds,
        },
        type: COLLECTIONS.COLLECTION.PERMISSIONS.CREATE.START,
    };
};

export const updatePermission = (permission) => {
    return {
        meta: {
            analytics: EventTypes.track,
        },
        payload: permission,
        type: COLLECTIONS.COLLECTION.PERMISSIONS.UPDATE.START,
    };
};

export const removePermission = (payload) => ({
    payload,
    type: COLLECTIONS.COLLECTION.PERMISSIONS.DELETE.START,
});

export const removePermissionSuccess = (payload?) => ({
    payload,
    type: COLLECTIONS.COLLECTION.PERMISSIONS.DELETE.COMPLETED,
});

export const removePermissionError = (error?) => ({
    error: true,
    payload: error,
    type: COLLECTIONS.COLLECTION.PERMISSIONS.DELETE.COMPLETED,
});

export const setContact = (contact) => {
    return {
        meta: {
            analytics: EventTypes.track,
        },
        payload: contact,
        type: COLLECTIONS.COLLECTION.PERMISSIONS.CONTACTS.SET,
    };
};
